import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http'; // ✅ أضيفي هذا

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import Lara from '@primeng/themes/lara';


import { routes } from './app.routes';

import { AuthRepository } from './features/auth/repository/auth.repository';
import { AuthApiRepository } from './features/auth/repository/auth-api.repository';

 
import { MessageService } from 'primeng/api';
import { UserOffsetInterceptor } from './core/interceptors/user-offset.interceptor';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { LoadingInterceptor } from './core/interceptors/loading.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideAnimationsAsync(),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()), // ✅ مهم جداً عشان HttpClient يشتغل
    providePrimeNG({
      theme: {
        preset: Aura,
        // preset: Lara,
     options: {
      darkModeSelector: 'body:not(.dark)'  
    }
        
      },
    }),
    MessageService,
    DatePipe,
    {
      provide: AuthRepository,
      useClass: AuthApiRepository
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UserOffsetInterceptor,
      multi: true
    },
      {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
     {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    }
  ]
};
